






import Vue from 'vue';

export default Vue.extend({
  name: "WaterParkMain2d",
  data: () => {
    return {};
  },
});
